import { encrypt } from '../helpers/Helpers';

export default async function CheckPassword({ crewCode, password, timestamp }) {
    const encryptedPassword = encrypt(password, process.env.REACT_APP_KEY);
    const url = "https://gops.azulhandling.com/LoginPage/procesos_seguros/CheckPassword.php";
    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': localStorage.getItem('token')
        },
        body: JSON.stringify({
            crewCode,
            password: encryptedPassword,
            timestamp
        })
    });
    return await res.json();
}